import ApiService from "@/service/api/ApiService";
import { map, catchError } from "rxjs/operators";
import { Observable, of } from "rxjs";
import UserSubscribeModel from "@/service/model/subscribe/UserSubscribeModel";
import SubscribeLectureInfoModel from "@/service/model/subscribe/SubscribeLectureInfoModel";
import SubscribeUserCheckModel from "@/service/model/subscribe/SubscribeUserCheckModel";
import PageDataModel from "@/service/model/common/PageDataModel";

class SubscribeService extends ApiService {
  /**
   * 사용자 구독 내역
   * @param userId
   */
  public getBlogList(userId: number): Observable<UserSubscribeModel> {
    return this.get<UserSubscribe[]>(
      "/user/subscriber",
      {
        userId
      },
      true
    ).pipe(
      map((data: UserSubscribe[]) => UserSubscribeModel.create(data)),
      catchError(() => of(new UserSubscribeModel()))
    );
  }

  /**
   * 구독에 유저 등록
   * @param userList
   * @param subscribeType
   * @param startedAt
   * @param endedAt
   */
  public updateSubscribeUser(
    userList: string[],
    subscribeType: string,
    startedAt: string,
    endedAt: string
  ): Observable<boolean> {
    return this.post<boolean>(
      "/subscribe/myLecture",
      { userList, subscribeType, startedAt, endedAt },
      true
    ).pipe(map((isSuccess: boolean) => isSuccess));
  }

  /**
   * 구독 렉처 조회
   * @param subscribeType
   */
  public getSubscribeLectureInfoList(
    subscribeType?: string | undefined
  ): Observable<SubscribeLectureInfo[]> {
    return this.get<SubscribeLectureInfo[]>(
      "/subscribe/lecture/list",
      {
        subscribeType
      },
      true
    ).pipe(
      map((list: SubscribeLectureInfo[]) =>
        list.map(info => SubscribeLectureInfoModel.create(info))
      ),
      catchError(() => of([]))
    );
  }

  /**
   * 구독에 렉처 업데이트
   * @param subscribeType
   * @param id
   */
  public updateSubscribeLecture(
    subscribeType: string,
    id: number[]
  ): Observable<string> {
    return this.put<string>(
      "/subscribe/lecture",
      { subscribeType, id },
      true
    ).pipe(map((isSuccess: string) => isSuccess));
  }

  /**
   * 유저 구독 해지
   * @param userIdList
   */
  public userSubscribeCancel(userIdList: number[]): Observable<boolean> {
    return this.put<boolean>(
      "/user/subscriberCancel",
      { userIdList },
      true
    ).pipe(map((isSuccess: boolean) => isSuccess));
  }

  /**
   * 구독 상품 중복 체크
   * @param userIds
   */
  public subscribeUserCheck(userIds: string): Observable<SubscribeUserCheck[]> {
    return this.get<SubscribeUserCheck[]>(
      "/subscribe/userCheck",
      { userIds },
      true
    ).pipe(
      map((list: SubscribeUserCheck[]) =>
        list.map(check => SubscribeUserCheckModel.create(check))
      ),
      catchError(() => of([]))
    );
  }

  /**
   * 구독 리스트 조회
   * @param page
   * @param itemSize
   */
  public retrieveSubscribeList(
    page: number,
    itemSize: number
  ): Observable<PageData<Subscribe>> {
    return this.get<PageData<Subscribe>>(
      "/subscribe/list",
      { page, itemSize },
      true
    ).pipe(
      map((subscribePageData: PageData<Subscribe>) =>
        PageDataModel.create(subscribePageData)
      ),
      catchError(() => of(new PageDataModel<Subscribe>()))
    );
  }
}

export const subscribeService = new SubscribeService();
